"use client";

import AboutHeroSection from "@/components/about/hero-section";
import OurStorySection from "@/components/about/our-story-section";
import WhyChooseSection from "@/components/shared/why-choose-section";
import TestimonialsSection from "@/components/shared/testimonials-section";
import FAQSection from "@/components/shared/faq-section";
import CTABannerSection from "@/components/shared/cta-banner-section";

export default function AboutPageView() {
  return (
    <>
      <AboutHeroSection />
      <OurStorySection />
      <WhyChooseSection variant="about" />
      <TestimonialsSection />
      <FAQSection />
      <CTABannerSection />
    </>
  );
}
